import httpService from "./httpService";
import { getBaseUrl } from "../helpers/baseUrlHelper";

const OrderActionService = {
	getOrderActions: async countryCode => {
		const baseUrl = getBaseUrl();
		let response = await httpService
			.get(baseUrl + `actions?countryCode=${countryCode}`, { useAuth: true })
			.then(response => {
				if (response.success) {
					return response.orderActions;
				} else {
					console.log(response);
					return [];
				}
			})
			.catch(error => {
				console.log(error);
				return [];
			});

		return response;
	}
};

export default OrderActionService;
